import { Box, Container, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import T from 'src/basic-components/text';
import Page from '../../components/Page';
import { LoginForm } from '../../sections/auth/login';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const HeaderStyle = styled('header')(({ theme }) => ({
  top: 0,
  zIndex: 9,
  lineHeight: 0,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  padding: theme.spacing(3),
  justifyContent: 'space-between',
  // [theme.breakpoints.up('md')]: {
  //   alignItems: 'flex-start',
  //   padding: theme.spacing(7, 5, 0, 7),
  // },
  // border: '1px solid red',
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function LoginPage() {
  return (
    <Page title="login" hideAppbar>
      <RootStyle>
        {/* <HeaderStyle>
          <Stack
            flex
            flexDirection="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{ width: '100%' }}
            gap={1}
          >
            {smUp && (
              <Typography variant="body2">
                <Stack flex flexDirection="row" gap={1}>
                  <T>dont-have-account</T>
                  <Link variant="subtitle2" component={RouterLink} to={PATH_AUTH.register}>
                    <T>register</T>
                  </Link>
                </Stack>
              </Typography>
            )}
            <Logo />
          </Stack>
        </HeaderStyle> */}

        <Container maxWidth="sm">
          <ContentStyle>
            <Stack
              direction="column"
              sx={{ height: 120, width: '100%', mb: 3 }}
              alignItems="center"
              justifyContent="center"
            >
              <img src="/logo/logo.png" height="120" style={{ marginBottom: '1rem' }} />
            </Stack>
            <Box sx={{ mb: 2 }}>
              <Typography>
                <T sx={{ fontSize: '1rem', fontWeight: '900' }}>login-to-your-account</T>
              </Typography>
            </Box>
            <LoginForm />
            {/* {!smUp && (
              <Typography variant="body2" sx={{ mt: 3 }}>
                <Stack flex flexDirection="row" alignItems="center" justifyContent="center" gap={1}>
                  <T>dont-have-account</T>
                  <Link variant="subtitle2" component={RouterLink} to={PATH_AUTH.register}>
                    <T>register</T>
                  </Link>
                </Stack>
              </Typography>
            )} */}
          </ContentStyle>
        </Container>
      </RootStyle>
    </Page>
  );
}
